import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import {
  BsDatepickerDirective,
  BsDaterangepickerContainerComponent,
  BsDatepickerContainerComponent,
} from 'ngx-bootstrap/datepicker';
import {
  Subject,
  Subscription,
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  finalize,
  map,
  of,
  takeUntil,
  tap,
  timeout,
} from 'rxjs';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SearchBarService } from '@modules/car-booking/services/search-bar.service';
import { scrollToTop, setRentalType } from '@shared/utils/helper';
import { SoctripTranslationService } from 'src/app/services/soctrip-translation/soctrip-translation.service';
import {
  RecommendPlace,
  RecommendPlaceRequest,
} from '@modules/car-booking/models/recommendPlaces.model';
import { TranslateService } from '@ngx-translate/core';
import { TIME_OUT_REQUEST } from '@shared/constant';
import {
  ISearchBarData,
  SearchBarDataService,
} from '@modules/car-booking/services/search-bar-data/search-bar-data.service';
import { PlaceType } from '@shared/enum/recommend-place.enum';
import { FooterService } from '@modules/car-booking/services/footer/footer.service';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { viLocale } from 'src/assets/i18n/vi';
import { DateTime } from 'luxon';
import { CustomDateTimeService } from '@shared/services/custom-date-time.service';
import { DateFormat } from '@shared/enum/date-format.enum';
import { ToastType } from '@shared/enum/toast-type';
import {
  GMPlaceCloneDTO,
  PlaceControllerService,
  SearchingPlaceControllerService,
} from '@assistant/angular-map-location-service';
import { GetApiService } from 'src/app/services/get-api.service';
import { LanguageService } from '@shared/services/language.service';
import { Calendar } from 'primeng/calendar';
import { CurrentLocationService } from '@shared/services/current-location.service';
import { GoogleAnalyticsService } from '@core/services/google-analytics.service ';
import { error } from 'console';
import { AdjustInstance, ADJUST_EVENT_TYPE } from '@core/services/adjust-instance';
import { Option } from '@shared/models/options.model';

defineLocale('vi', viLocale);
export type DropdownValue = string | number;

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  providers: [MessageService],
})
export class SearchBarComponent implements OnChanges, OnDestroy {
  @ViewChild('addressPanel') addressPanel: OverlayPanel;
  @ViewChild('airportPanel') airportPanel: OverlayPanel;
  @ViewChild('filterAmountPeoplePanel') filterAmountPeoplePanel: OverlayPanel;
  // @ViewChild('selectOptionRef') selectOptionRef: ElementRef;
  @ViewChild('selectDateCheckIn') selectDateCheckIn!: ElementRef;
  @ViewChild('selectDateCheckout') selectDateCheckout!: ElementRef;
  // @ViewChild('rangeCalendarCheckIn') rangeCalendarCheckIn: ElementRef;
  // @ViewChild('rangeCalendarCheckOut') rangeCalendarCheckOut: ElementRef;

  @ViewChild('rangeCalendarPanel') rangeCalendarPanel: OverlayPanel;
  @ViewChild('daterangepicker', { static: false })
  daterangepicker: BsDatepickerDirective;
  @ViewChild('bsDaterangepicker', { read: ElementRef })
  bsDaterangepicker: ElementRef;

  @ViewChild('dateCalendarPanel') dateCalendarPanel: OverlayPanel;
  @ViewChild('datepicker', { static: false })
  datepicker: BsDatepickerDirective;
  @ViewChild('bsDatepicker', { read: ElementRef })
  bsDatepicker: ElementRef;

  // @ViewChild('contentCalendarPanel', { static: true })
  // contentCalendarPanel: ElementRef;

  @Input() receivedData: any;
  @Input() isMap: boolean;

  @Output() searchBarUpdateData = new EventEmitter<Event>();
  @Output() selectDateValue = new EventEmitter<Event>();
  @Output() selectAtDateValue = new EventEmitter<Event>();
  @Output() onSwitchRentalType = new EventEmitter<string>();

  private searchModelChangeSubscription: Subscription;
  private searchAirportChangeSubscription: Subscription;

  pipe = new DatePipe('en-US');
  destination: string;
  currentDate: Date = new Date(Date.now());
  maxDate: Date | null;
  startDate: Date;
  tempDateCheckIn: string | null;
  tempDateCheckOut: string | null;
  // searchLocation: string = '';
  searchText: string = '';
  airportSearchText: string = '';
  searchModelChanged: Subject<string> = new Subject<string>();
  searchAirportChanged: Subject<string> = new Subject<string>();
  selectedDates: (Date | undefined)[] | undefined;
  selectedDate: Date | undefined;
  selectedTime: any;
  valueCheckIn: string | null;
  valueCheckOut: string | null;
  valueSingleDate: string | null;
  valueSelectDate: Date[] = [];
  isFocused: boolean = false;
  placeholderText: string = 'Enter place';
  yourLocationText: string;
  isSearchByLocation = false;
  addressList: RecommendPlace[] = [];
  airportList: any[] = [];
  isLoading: boolean = false;
  destroy$: Subject<void> = new Subject();
  dataSearch: ISearchBarData;
  isClickedInput = false;
  atDirection: number = 0;
  rentalDays: any;
  hidenPicker: boolean = false;
  // selectedLanguage = localStorage.getItem('user_profile');
  language: string = 'en';
  dateFormat: string = 'primeng.dateFormat';
  airportSelectPlaceholder: string;
  dropoffPlaceholder: string;
  rentalTypeOptions: Option[] = [
    {
      label: 'common.component.booking_details_content.without_driver',
      value: 'is_without_driver',
    },
    {
      label: 'common.component.booking_details_content.with_driver',

      value: 'is_with_driver',
    },
    {
      label: 'common.component.booking_details_content.airport_tranfer',
      value: 'is_airport_transfer',
    },
  ];
  selectedRentalType: string;
  withDriverRentalTypeOptions: Option[];
  selectedWithDriverRentalType: string;
  previousRentalType: string | undefined = undefined;
  countryCode: string = 'VI';
  clientPosition: any;
  famousPlace: any[] = [];
  recommendAirport: any[] = [];
  constructor(
    private route: ActivatedRoute,
    private messageService: MessageService,
    private searchResultService: SearchBarService,
    private soctripTranslationService: SoctripTranslationService,
    private translateService: TranslateService,
    private searchBarDataService: SearchBarDataService,
    private footerService: FooterService,
    private searchingPlaceControllerService: SearchingPlaceControllerService,
    private renderer: Renderer2,
    private customDateTimeService: CustomDateTimeService,
    private getApiSerive: GetApiService,
    private languageService: LanguageService,
    private router: Router,
    private currentLocationService: CurrentLocationService,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private placeControllerService: PlaceControllerService
  ) {
    this.selectedRentalType = route.snapshot.queryParams['rental_type'] || 'is_without_driver';
    this.selectedWithDriverRentalType = route.snapshot.queryParams['rent_by'] || 'both';
  }

  ngOnInit(): void {
    // if (this.selectedLanguage !== null) {
    //   const userProfile = JSON.parse(this.selectedLanguage);
    //   if (
    //     typeof userProfile === 'object' &&
    //     'language' in userProfile &&
    //     (userProfile.language as string).toLocaleLowerCase() === 'vi'
    //   ) {
    //     this.localeService.use('vi');
    //   } else {
    //     this.localeService.use('en');
    //   }
    // } else {
    //   this.localeService.use('en');
    // }
    this.getCurrentPosition();
    this.getCountryCode();
    this.language = this.languageService.currentLanguage$.value || 'en';
    this._OnInit();
    this.handleSearchPlaces();
    this.handleSearchAirport();

    this.withDriverRentalTypeOptions = [
      {
        label: this.soctripTranslationService.getTranslation('SEARCH.RENT_BY_HOUR'),
        value: 'hour',
      },
      {
        label: this.soctripTranslationService.getTranslation('SEARCH.RENT_BY_KM'),
        value: 'distance',
      },
      {
        label: this.soctripTranslationService.getTranslation('SEARCH.RENT_BY_KM_OR_HOUR'),
        value: 'both',
      },
    ];
    this.placeholderText = 'SEARCH.PLACEHOLDER.PLACE';
    this.yourLocationText = this.soctripTranslationService.getTranslation('SEARCH.YOUR_LOCATION');
    this.airportSelectPlaceholder = this.soctripTranslationService.getTranslation(
      'SEARCH.PLACEHOLDER.SELECT_AIRPORT'
    );
    this.dropoffPlaceholder = this.soctripTranslationService.getTranslation(
      'SEARCH.PLACEHOLDER.DROP_OFF_LOCATION'
    );

    this.atDirection = Number(this.route.snapshot.queryParamMap.get('at_direction')) ?? 0;
  }

  getCountryCode() {
    this.getApiSerive
      .getCurrentRegion()
      .pipe(
        takeUntil(this.destroy$),
        map((response) => ({
          countryCode: response?.success ? response?.data[0].country_code : 'US',
          zipCode: response?.success ? response?.data[0].zipcode : '',
        })),
        catchError(() => of({ countryCode: 'US', zipCode: '' }))
      )
      .subscribe({
        next: (regionCodeResponse) => {
          this.countryCode = regionCodeResponse.countryCode;
          this.currentLocationService.storeCurrentCountryCode(
            regionCodeResponse.countryCode,
            regionCodeResponse.zipCode
          );
        },
        complete: () => {
          if (this.countryCode === 'VN') {
            this.famousPlace = FAMOUS_PLACE_VN;
            this.recommendAirport = RECOMMEND_AIRPORT_VN;
          } else {
            this.getApiSerive.getAirportByKeyword(1, 10, '', this.language).subscribe({
              next: (response) => {
                if (response.success) {
                  this.famousPlace = response.data?.continents.flatMap(
                    (continent: any) => continent.destination_list
                  );
                  this.recommendAirport = [];
                }
              },
              error: () => {},
            });
          }
        },
      });
  }
  _OnInit() {
    const queryParams = this.route.snapshot.queryParams;
    if (
      (queryParams['checkin'] &&
        queryParams['checkin'] < this.pipe.transform(Date.now(), 'yyyy-MM-dd')!) ||
      (queryParams['checkout'] &&
        queryParams['checkout'] < this.pipe.transform(Date.now(), 'yyyy-MM-dd')!)
    ) {
      const todayMilliseconds = DateTime.fromJSDate(new Date())
        .set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        })
        .toMillis();
      this.router.navigate([], {
        queryParams: {
          start_time:
            Number(queryParams['start_time']) < todayMilliseconds
              ? todayMilliseconds
              : queryParams['start_time'],
          checkin:
            Number(queryParams['start_time']) < todayMilliseconds
              ? this.pipe.transform(Date.now(), 'yyyy-MM-dd')
              : queryParams['checkin'],
          end_time:
            Number(queryParams['end_time']) < todayMilliseconds
              ? todayMilliseconds
              : queryParams['end_time'],
          checkout:
            Number(queryParams['end_time']) < todayMilliseconds
              ? this.pipe.transform(Date.now(), 'yyyy-MM-dd')
              : queryParams['checkout'],
        },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }
    this.receivedData.at_iata_code = this.receivedData.at_iata_code || queryParams['at_iata_code'];
    this.footerService.getFooterSetting().subscribe((setting) => {
      this.receivedData.currency = setting.currency;
      this.receivedData.country_code = setting.lang?.country_code;
    });
    this.dataSearch = {
      destination: this.destination,
      rooms: this.receivedData.numberOfRooms,
      check_in: this.receivedData.initCheckInDate!,
      check_out: this.receivedData.initCheckOutDate,
      at_checkin: this.receivedData.initAirportPickupDate,
      currency: this.receivedData.currency,
      country_code: this.receivedData.country_code,
      lat: this.receivedData.latitude,
      lon: this.receivedData.longitude,
      place_id: this.receivedData.id,
      // geo_type: this.receivedData.geo_type,
      rental_type: this.receivedData.rental_type,
      rent_by: this.receivedData.rent_by,
      at_iata_code: this.receivedData.at_iata_code,
      at_airport_name: this.receivedData.at_airport_name,
      at_searchText: this.receivedData.at_searchText,
      at_pickup_date: this.receivedData.at_pickup_date,
      at_pickup_time: this.receivedData.initAirportPickupTime,
      at_direction: this.receivedData.at_direction,
    };

    this.searchBarDataService.setSearchData(this.dataSearch);

    this.selectedDates = [this.receivedData.initCheckInDate!, this.receivedData.initCheckOutDate];
    this.selectedDate = this.receivedData.initAirportPickupDate;
    this.pickupTime = this.receivedData.initAirportPickupTime;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['receivedData']) {
      this._OnInit();
    }
  }

  onInputChange(event: Event) {
    if (!this.addressPanel.overlayVisible) {
      this.addressPanel?.show(event);
    }
    const inputSearchElement = event.target as HTMLInputElement;
    this.receivedData.selectedHotel = inputSearchElement.value;
    this.searchModelChanged.next(inputSearchElement.value);
  }
  onResetLocationInput() {
    this.receivedData.selectedHotel = '';
    this.dataSearch.destination = '';

    this.searchModelChanged.next('');
  }
  onInputAirportChange(event: any) {
    if (!this.airportPanel.overlayVisible) {
      this.airportPanel?.show(event);
    }
    const inputSearchElement = event.target as HTMLInputElement;
    this.receivedData.selectedAirport = inputSearchElement.value;
    this.searchAirportChanged.next(inputSearchElement.value);
  }

  handleSearchPlaces() {
    this.searchModelChangeSubscription = this.searchModelChanged
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchText: string) => {
        const params: RecommendPlaceRequest = {
          keyword: searchText,
        };
        this.searchText = searchText;
        this.getRecommendPlaces(params);
        this.isClickedInput = false;

        this.receivedData.latitude = undefined;
        this.receivedData.longitude = undefined;
      });
  }
  handleSearchAirport() {
    this.searchAirportChangeSubscription = this.searchAirportChanged
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchText: string) => {
        this.airportSearchText = searchText;
        this.getSuggestedAirports(this.airportSearchText);
        // this.isClickedInput = false;
      });
  }
  getRecommendPlaces(paramsSearch?: RecommendPlaceRequest) {
    this.isLoading = true;
    this.isSearchByLocation = false;
    const isContainAdministrative =
      this.selectedRentalType === 'is_airport_transfer' ? false : true;
    this.searchingPlaceControllerService
      .searchPlace(
        paramsSearch?.keyword ?? undefined,
        undefined,
        undefined,
        undefined,
        false,
        undefined,
        paramsSearch?.keyword ? undefined : this.clientPosition?.latitude ?? undefined,
        paramsSearch?.keyword ? undefined : this.clientPosition?.longitude ?? undefined,
        undefined,
        true
      )
      .pipe(
        takeUntil(this.destroy$),
        timeout(TIME_OUT_REQUEST),
        tap((res) => {
          if (res.success) {
            this.addressList = [];

            res?.data?.data?.forEach((item: any) => {
              let resItem: RecommendPlace = {
                object_name: item.main_text,
                object_type: 'CAR',
                city: item?.adt_divisions
                  ? item?.adt_divisions
                  : this.selectedRentalType !== 'is_airport_transfer'
                  ? 'CITY'
                  : '',
                state: 'STATE',
                country_name: '',
                object_image_url: '',
                num_of_objects: 1,
                property_id: '',
                bg_color: '',
                icon_class: '',
                lat: item.lat,
                lon: item.lon,
                id: item.id,
                g_id: item.g_id,
                session_token: item.session_token,
                addr: item.addr,
                // geo_type: item.geo_type,
              };

              if (this.addressList.filter((e) => e.object_name === item.main_text).length == 0) {
                this.addressList.push(resItem);
              }
            });
          } else if (!res.success && paramsSearch) {
            this.addressList = [];
          }
        }),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe();

    // .subscribe((res:any)=>{
    //   if(res.success){
    //     res.data.forEach((item:any)=>{
    //       let resItem: RecommendPlace = {
    //         object_name: item.main_text,
    //         object_type: 'CAR',
    //         city: '',
    //         state: '',
    //         country_name: item.country,
    //         object_image_url: '',
    //         num_of_objects: 1,
    //         property_id: '',
    //         bg_color: '',
    //         icon_class: '',
    //     }
    //     })

    //   }

    // })
    // this.bookingFamousPlacesControllerService.suggestLocations(
    //     body,
    //     DEFAULT_SEARCH_PARAMS.page_size,
    //     this.receivedData.country_code,
    //     paramsSearch?.keyword
    //   )
    //   .pipe(
    //     takeUntil(this.destroy$),
    //     timeout(TIME_OUT_REQUEST),
    //     tap((res: RecommendPlaceResponse) => {
    //       if (res.success) {
    //         this.addressList = this.getPlaceType(res.data!);
    //       } else if (!res.success && paramsSearch) {
    //         this.addressList = [];
    //       }
    //     }),
    //     finalize(() => {
    //       this.isLoading = false;
    //     })
    //   )
    //   .subscribe();
  }

  getCurrentPosition() {
    try {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
          const {
            coords: { longitude, latitude },
          } = position;
          this.clientPosition = { latitude, longitude };
        });
      } else {
        this.messageService.add({
          severity: ToastType.WARNING,
          detail: this.soctripTranslationService.getTranslation(
            'SEARCH.BROWSER_NOT_SUPPORT_GEOLOCATION'
          ),
        });
      }
    } catch (error) {
      throw error;
    }
  }
  handleCarNearU() {
    try {
      navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
        const {
          coords: { longitude, latitude },
        } = position;
        this.yourLocationText =
          this.soctripTranslationService.getTranslation('SEARCH.YOUR_LOCATION');
        this.receivedData.selectedHotel = this.yourLocationText;
        this.dataSearch = {
          ...this.dataSearch,
          destination: this.yourLocationText,
        };
        this.searchBarDataService.setSearchData({
          ...this.dataSearch,
          destination: this.yourLocationText,
        });
        this.receivedData.latitude = latitude;
        this.receivedData.longitude = longitude;
        this.receivedData.id = null;

        this.addressPanel.hide();
        this.isSearchByLocation = true;
      });
    } catch (error) {
      throw error;
    }
  }

  ngOnDestroy(): void {
    this.searchModelChangeSubscription?.unsubscribe();
    this.searchAirportChangeSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    this.hideOverlayAddress();
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const dateRangePickerInputs = document.querySelectorAll('.date-range-picker');
    let clickedInsidePicker = false;

    const dateRangePickerArray = Array.from(dateRangePickerInputs);
    for (const input of dateRangePickerArray) {
      if (input.contains(targetElement)) {
        clickedInsidePicker = true;
        break;
      }
    }
    if (!clickedInsidePicker) {
      // const element = document.querySelector('.bs-datepicker') as HTMLElement;
      this.daterangepicker?.hide();
    }
  }

  onClickInputPlace(event: Event) {
    this.addressPanel.show(event);
    if (!this.isClickedInput) {
      this.isClickedInput = true;
    } else {
      return;
    }
    // CASE: Search near by
    if (
      (this.isSearchByLocation || this.receivedData.latitude) &&
      this.receivedData.selectedHotel === this.yourLocationText
    ) {
      this.receivedData.selectedHotel = '';
      this.getRecommendPlaces();
      return;
    }
    // CASE: Already selected hotel
    if (this.receivedData.selectedHotel) {
      this.getRecommendPlaces({ keyword: this.receivedData.selectedHotel });
      return;
    }
    // CASE: First time click
    if (!this.addressList.length && !this.searchText) {
      this.getRecommendPlaces();
    }
  }
  getSuggestedAirports(airportSearchTexT?: string) {
    if (!airportSearchTexT || !airportSearchTexT.trim()) {
      return;
    }
    this.getApiSerive.getAirportByKeyword(1, 10, airportSearchTexT || '', this.language).subscribe({
      next: (response) => {
        if (response.success) {
          this.airportList = response.data.airports;
        } else {
          this.airportList = [];
        }
      },
      error: () => {
        this.airportList = [];
      },
    });
  }

  onClickAirportInput(event: Event) {
    this.airportPanel.show(event);
    if (!this.isClickedInput) {
      this.isClickedInput = true;
    } else {
      return;
    }

    if (!this.airportList.length && !this.airportSearchText) {
      this.getSuggestedAirports();
    }
  }

  hideOverlayAddress() {
    this.addressPanel.hide();
  }

  onInputPlaceFocus() {
    this.placeholderText = 'SEARCH.PLACEHOLDER.PLACE';
    this.isFocused = true;
  }

  onShowAddressOverlay(type: 'ADDRESS' | 'AIRPORT') {
    setTimeout(() => {
      if (type === 'ADDRESS') {
        const panelEl = this.addressPanel.container as HTMLElement;
        const isCarRental = document.querySelector('#t-find-car-near-you') as HTMLElement;
        if (panelEl) {
          const currentTop = parseFloat(panelEl.style.top || '0');
          // Giả định nếu panel đang hiển thị phía trên anchor (top < 200px)
          if (currentTop < 200) {
            panelEl.style.top = isCarRental ? '100px' : '140px';
          }
        }
      }
      //  else {
      //   const panelEl = this.airportPanel.container as HTMLElement;
      //   if (panelEl) {
      //     const currentTop = parseFloat(panelEl.style.top || '0');
      //     console.log("currentTop: ", currentTop);
      //     if (currentTop < 300) {
      //       panelEl.style.top = '175px';
      //     }
      //   }
      // }
    }, 0);
  }
  onHideAddressOverlay() {
    this.isClickedInput = false;
    this.receivedData.selectedHotel =
      this.dataSearch.destination || this.route.snapshot.queryParamMap.get('destination');
  }
  onHideAirportOverlay() {
    this.isClickedInput = false;
    // this.receivedData.selectedHotel =
    //   this.dataSearch.destination || this.route.snapshot.queryParamMap.get('destination');
  }
  onInputPlaceBlur() {
    this.isFocused = false;
    if (!this.addressList.length) return; // if not have data and click outside
    if (!this.receivedData.selectedHotel) {
      this.placeholderText = 'SEARCH.PLACEHOLDER.PLACE';
      return;
    }
    if (this.isSearchByLocation) {
      this.dataSearch = {
        ...this.dataSearch,
        destination: this.yourLocationText,
      };
      this.searchBarDataService.setSearchData({
        ...this.dataSearch,
        destination: this.yourLocationText,
      });
      this.receivedData.selectedHotel = this.yourLocationText;
      return;
    }
    this.dataSearch = {
      ...this.dataSearch,
      destination: this.addressList?.[0]?.object_name,
    };
    this.searchBarDataService.setSearchData({
      ...this.dataSearch,
      destination: this.addressList?.[0]?.object_name,
    });
    this.receivedData.property_id = this.addressList?.[0]?.property_id;
    // this.receivedData.dest_type = this.addressList?.[0]?.property_id
    //   ? PlaceType.PROPERTY.toUpperCase()
    //   : PlaceType.CITY.toUpperCase();
  }

  onDateRangeChange(event: any) {
    if (event && DateTime.fromJSDate(event[0]).isValid && DateTime.fromJSDate(event[1]).isValid) {
      if (DateTime.fromJSDate(event[0]).valueOf() === DateTime.fromJSDate(event[1]).valueOf()) {
        this.valueSelectDate = event;
        this.startDate = event[0];
        this.selectDateValue.emit(event);
        this.valueCheckIn = this.formatDateTimeTemplate(event[0]);
        this.valueCheckOut = this.formatDateTimeTemplate(event[0]);
        this.tempDateCheckIn = this.formatDateTimeTemplate(event[0]);
        this.tempDateCheckOut = this.formatDateTimeTemplate(event[0]);

        this.maxDate = null;
        this.rentalDays = DateTime.fromJSDate(event[1])
          .plus({ day: 1 })
          .diff(DateTime.fromJSDate(event[0]), 'days')
          .days.toFixed(0);
        this.dataSearch = {
          ...this.dataSearch,
          check_in: this.formatDateTimeTemplate(event[0]),
          check_out: this.formatDateTimeTemplate(event[0]),
        };
        this.searchBarDataService.setSearchData({
          ...this.dataSearch,
          check_in: this.formatDateTimeTemplate(event[0]),
          check_out: this.formatDateTimeTemplate(event[0]),
        });
        return;
        // this.messageService.add({
        //   severity: ToastType.ERROR,
        //   detail: this.soctripTranslationService.getTranslation(
        //     'MESSAGE.CHECK_IN_AND_CHECKOUT_MUST_DIFFERENT'
        //   ),
        // });
        // this.valueCheckIn = null;
        // this.valueCheckOut = null;
        // this.tempDateCheckIn = null;
        // this.tempDateCheckOut = null;
        // this.hidenPicker = false;
        // this.dataSearch = {
        //   ...this.dataSearch,
        //   check_in: null,
        //   check_out: null,
        // };
        // this.searchBarDataService.setSearchData({
        //   ...this.dataSearch,
        // });
        // return;
      }

      this.valueSelectDate = event;
      this.startDate = event[0];
      this.selectDateValue.emit(event);
      this.valueCheckIn = this.formatDateTimeTemplate(event[0]);
      this.valueCheckOut = this.formatDateTimeTemplate(event[1]);
      this.tempDateCheckIn = this.formatDateTimeTemplate(event[0]);
      this.tempDateCheckOut = this.formatDateTimeTemplate(event[1]);
      this.maxDate = null;
      this.rentalDays = DateTime.fromJSDate(event[1])
        .plus({ day: 1 })
        .diff(DateTime.fromJSDate(event[0]), 'days')
        .days.toFixed(0);

      this.dataSearch = {
        ...this.dataSearch,
        check_in: this.formatDateTimeTemplate(event[0]),
        check_out: this.formatDateTimeTemplate(event[1]),
      };
      this.searchBarDataService.setSearchData({
        ...this.dataSearch,
        check_in: this.formatDateTimeTemplate(event[0]),
        check_out: this.formatDateTimeTemplate(event[1]),
      });
    } else {
      this.valueCheckIn = null;
    }
    this.hidenPicker = false;
  }
  onSingleDateChange(event: any) {
    if (event) {
      this.selectedDate = event;
      this.valueSingleDate = this.formatDateTimeTemplate(event);
      this.receivedData.at_pickup_date = event;
      this.selectAtDateValue.emit(event);
      this.dataSearch = {
        ...this.dataSearch,
        at_checkin: this.formatDateTimeTemplate(event),
        at_pickup_date: this.valueSingleDate,
      };
      this.searchBarDataService.setSearchData(this.dataSearch);
    }
    // if (event) {
    //   this.selectedDate = event;
    //   this.valueSingleDate = this.formatDateTimeTemplate(event);
    // } else {
    //   this.selectedDate = new Date();
    //   this.valueSingleDate = this.formatDateTimeTemplate(new Date());
    // }
    // this.valueSingleDate = this.formatDateTimeTemplate(event);
    // this.receivedData.at_pickup_date = event;
  }
  customerFooter() {
    const footerHTML = `
      <div class="flex gap-[8px] w-full justify-between items-center">
        <div class="flex flex-col justify-between">
          <p class="font-semibold">
            ${this.valueCheckIn} - ${
      this.valueCheckOut !== null
        ? this.valueCheckOut
        : this.soctripTranslationService.getTranslation('SEARCH.DATE_PICKET_SELECT_END_DATE')
    }
          </p>
          <p class="flex items-center text-sm gap-1">
            <span>${this.soctripTranslationService.getTranslation(
              'SEARCH.DATE_PICKET_RENTALDAYS'
            )}:</span>
            <span>${this.soctripTranslationService.getTranslationWithParam(
              'pluralization.total_days',
              { count: this.rentalDays }
            )}</span>
            <span class="tooltip"></span>
          </p>
        </div>
      </div>
    `;
    // <div class="wrap-btn">
    //   <button class="text-white rounded-lg bg-[#2563eb] py-3 px-5" id="continue-btn">${this.translateService.instant('SEARCH.DATE_PICKET_CONTINUE')}</button>
    // </div>
    const element = document.querySelector('.bs-datepicker') as HTMLElement;
    element.style.display = 'block';
    const elements = document.querySelector('bs-daterangepicker-container') as HTMLElement;

    const existingFooter = document.querySelector('.custom-datepicker-footer') as HTMLElement;
    if (existingFooter) {
      this.renderer.removeChild(element, existingFooter);
    }

    const footer = this.renderer.createElement('div');
    this.renderer.addClass(footer, 'custom-datepicker-footer');
    this.renderer.setProperty(footer, 'innerHTML', footerHTML);
    this.renderer.appendChild(element, footer);
    const continueBtn = document.querySelector('#continue-btn') as HTMLElement;
    if (continueBtn) {
      this.renderer.listen(continueBtn, 'click', () => this.onContinueClick());
    }
    elements.style.zIndex = this.receivedData.zIndexCalendar;
  }

  onContinueClick() {
    this.hidenPicker = true;
    this.daterangepicker.hide();
  }

  // ngAfterViewInit() {
  //   this.daterangepicker.bsValueChange.subscribe((date: Date[]) => {
  //     setTimeout(() => {
  //       this.daterangepicker.show();
  //       this.customerFooter()
  //     });
  //   });
  // }

  showCalendarDayCheckIn(event: Event) {
    this.daterangepicker.hide();
    this.daterangepicker.minDate = new Date(Date.now());
    this.daterangepicker.show();
    this.customerFooter();
  }
  showSingleCalendar(event: Event) {
    this.datepicker.hide();
    this.datepicker.minDate = new Date(Date.now());
    this.datepicker.show();
  }

  showCalendarDayCheckOut(event: Event) {
    this.daterangepicker.show();
    this.customerFooter();
  }

  onDatepickerHide() {
    if (this.valueCheckIn && !this.valueCheckOut) {
      this.valueCheckOut = this.valueCheckIn;
      this.tempDateCheckIn = this.valueCheckIn;
      this.tempDateCheckOut = this.valueCheckIn;
      this.selectedDates = [this.currentDate, this.currentDate];
    } else {
      this.valueCheckIn = this.tempDateCheckIn;
      this.valueCheckOut = this.tempDateCheckOut;
    }
    this.maxDate = null;
    this.currentDate = new Date(Date.now());
    // if(!this.hidenPicker){
    //   this.daterangepicker.show();
    //   this.customerFooter()
    // }
  }

  onSingleDatepickerHide() {
    this.currentDate = new Date(Date.now());
  }
  onDatepickerShown(): void {
    this.selectDateCheckIn?.nativeElement.focus();
    const datePickerInstance: BsDaterangepickerContainerComponent =
      this.daterangepicker['_datepicker'].instance;
    datePickerInstance.valueChange
      .pipe(filter((value) => value && value[0] && !value[1]))
      .subscribe((value: Date[]) => {
        if (value) {
          const [startDate] = value;
          this.valueCheckIn = this.formatDateTimeTemplate(startDate);
          this.valueSelectDate = [startDate, startDate];

          this.currentDate = startDate;
          this.maxDate = DateTime.fromJSDate(startDate).plus({ days: 90 }).toJSDate();
          this.dataSearch = {
            ...this.dataSearch,
            check_in: this.formatDateTimeTemplate(startDate),
            check_out: this.formatDateTimeTemplate(startDate),
          };
          this.searchBarDataService.setSearchData({
            ...this.dataSearch,
            check_in: this.formatDateTimeTemplate(startDate),
            check_out: this.formatDateTimeTemplate(startDate),
          });
          this.selectDateValue.emit(this.valueSelectDate as any);
          this.selectDateCheckout.nativeElement.focus();
          this.valueCheckOut = null;
          this.customerFooter();
        }
      });
  }
  onSingleDatepickerShown() {
    const datePickerInstance: BsDatepickerContainerComponent =
      this.datepicker['_datepicker'].instance;
    datePickerInstance.valueChange.subscribe((value) => {
      this.valueSingleDate = this.formatDateTimeTemplate(value);
      this.selectedDate = value;
      this.dataSearch = {
        ...this.dataSearch,
        at_checkin: this.formatDateTimeTemplate(value),
        at_pickup_date: this.valueSingleDate,
      };
      this.searchBarDataService.setSearchData({
        ...this.dataSearch,
        at_pickup_date: this.valueSingleDate,
      });
      this.selectAtDateValue.emit(value as any);
    });
  }
  onHotelSelected(address: RecommendPlace) {
    // this.receivedData.dest_type = address.property_id
    //   ? PlaceType.PROPERTY.toUpperCase()
    //   : PlaceType.CITY.toUpperCase();
    const cloneDataBody: GMPlaceCloneDTO = {
      place_id: address.id,
      g_id: address.g_id,
      session_token: address.session_token,
    };
    if (address.session_token) {
      this.placeControllerService.cloneGmData(cloneDataBody).subscribe({
        next: (response) => {
          this.updaterecievedData(address);
        },
        error: (err) => {
          console.error('err', err);
        },
      });
    } else {
      this.updaterecievedData(address);
    }

    this.hideOverlayAddress();
  }
  private updaterecievedData(address: RecommendPlace) {
    this.receivedData.property_id = address.property_id;
    this.receivedData.latitude = address.lat;
    this.receivedData.longitude = address.lon;
    this.receivedData.id = address.id;
    this.receivedData.addr = address.addr ?? '';
    this.receivedData.selectedHotel = address.object_name;
    // this.receivedData.geo_type = address.geo_type;
    this.dataSearch = {
      ...this.dataSearch,
      destination: address.object_name,
      place_id: address.id,
      // geo_type: address.geo_type,
    };
    this.searchBarDataService.setSearchData({
      ...this.dataSearch,
    });
  }

  onSelectAirport(airport: any) {
    this.receivedData.at_searchText = `${airport.city_name} (${airport.iata_code})`;
    this.airportSearchText = airport.airport_name;
    this.receivedData.at_airport_name = airport.airport_name;
    this.receivedData.at_iata_code = airport.iata_code;
    this.dataSearch = {
      ...this.dataSearch,
      at_airport_name: airport.airport_name,
      at_searchText: `${airport.city_name} (${airport.iata_code})`,
      at_iata_code: airport.iata_code,
    };
    this.searchBarDataService.setSearchData({
      ...this.dataSearch,
    });
    this.airportPanel.hide();
  }

  convertDateDefault(date: any) {
    const originalDate = new Date(date);

    const year = originalDate.getFullYear();
    const month = String(originalDate.getMonth() + 1).padStart(2, '0');
    const day = String(originalDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  // Handle search
  onClickSearch() {
    AdjustInstance.trackingEvent(ADJUST_EVENT_TYPE.CAR_SEARCH.label);
    if (
      (!this.valueCheckIn || !this.valueCheckOut) &&
      this.selectedRentalType !== 'is_with_driver'
    ) {
      this.messageService.add({
        severity: ToastType.ERROR,
        detail: this.soctripTranslationService.getTranslation(
          'MESSAGE.CHECK_IN_AND_CHECKOUT_REQUIRED'
        ),
      });
      return;
    }
    if (
      this.receivedData.selectedHotel === undefined ||
      this.receivedData.selectedHotel?.trim().length === 0
    ) {
      this.messageService.add({
        severity: ToastType.ERROR,
        detail: this.soctripTranslationService.getTranslation('MESSAGE.ENTER_PLACE_OR_HOTEL'),
      });
      return;
    } else {
      if (!this.selectedSeconds) {
        this.selectPickupTime();
        this.receivedData.at_pickup_time =
          this.pickupTime?.getHours() * 3600 + this.pickupTime?.getMinutes() * 60;
      } else {
        this.receivedData.at_pickup_time = this.selectedSeconds;
      }
      scrollToTop('smooth');
      const value = this.getValueSearchParams();

      this.searchResultService.setItemStorage('data-search-result', value);
      this.searchBarUpdateData.emit(this.receivedData);
      this.googleAnalyticsService.searchEvent(value.destination_name, this.selectedRentalType);
    }
  }

  onClickSearchAirport() {
    if (
      this.receivedData.selectedHotel === undefined ||
      this.receivedData.selectedHotel?.trim().length === 0
    ) {
      this.messageService.add({
        severity: ToastType.ERROR,
        detail: this.soctripTranslationService.getTranslation('MESSAGE.ENTER_PLACE_OR_HOTEL'),
      });
      return;
    }
    if (!this.receivedData.at_iata_code) {
      this.messageService.add({
        severity: ToastType.ERROR,
        detail: this.soctripTranslationService.getTranslation('MESSAGE.ENTER_AIRPORT'),
      });
      return;
    }
    if (!this.selectedSeconds) {
      this.selectPickupTime();
      this.receivedData.at_pickup_time =
        this.pickupTime?.getHours() * 3600 + this.pickupTime?.getMinutes() * 60;
    } else {
      this.receivedData.at_pickup_time = this.selectedSeconds;
    }
    scrollToTop('smooth');
    const value = this.getValueSearchParams();
    this.searchResultService.setItemStorage('data-search-result', value);
    this.searchBarUpdateData.emit(this.receivedData);
  }

  getValueSearchParams() {
    const checkInDate = this.pipe.transform(this?.valueSelectDate[0], 'yyyy-MM-dd') || null;
    const checkOutDate = this.pipe.transform(this.valueSelectDate[1], 'yyyy-MM-dd') || null;
    const atPickupDate =
      this.pipe.transform(
        !isNaN(this.selectedDate?.getTime()!) ? this.selectedDate : new Date().getTime(),
        'yyyy-MM-dd'
      ) || null;
    this.receivedData.rental_type = this.selectedRentalType;
    this.receivedData.rent_by = this.selectedWithDriverRentalType;
    this.receivedData.at_direction = this.atDirection;
    if (!this.receivedData.latitude || !this.receivedData.longitude) {
      this.receivedData = {
        ...this.receivedData,
        selectedHotel: this.addressList?.[0]?.object_name,
        latitude: this.addressList?.[0]?.lat,
        longitude: this.addressList?.[0]?.lon,
      };
    }
    let value = {
      ...this.receivedData,
      destination_name: this.receivedData.selectedHotel,
      destination: this.receivedData.selectedHotel,
      country_code: this.receivedData.country_code,
      checkin: checkInDate!,
      checkout: checkOutDate!,
      currency: this.receivedData.currency,
      property_id: this.receivedData.property_id,
      page_num: 0,
      rental_type: this.selectedRentalType,
      rent_by: this.selectedWithDriverRentalType,
      at_direction: this.atDirection,
      at_pickup_date: this.selectedRentalType === 'is_airport_transfer' ? atPickupDate! : null,
      at_pickup_time: this.selectedSeconds,
    };

    setRentalType(this.selectedRentalType);
    if (
      this.isSearchByLocation ||
      this.receivedData.selectedHotel === this.translateService.instant('SEARCH.YOUR_LOCATION')
    ) {
      value = Object.assign(
        {
          latitude: this.receivedData?.latitude,
          longitude: this.receivedData?.longitude,
        },
        value
      );
    }
    return value;
  }

  comparePreviousAndCurrentRentalType() {
    const condition1 =
      (this.previousRentalType === 'is_with_driver' ||
        this.previousRentalType === 'is_without_driver' ||
        this.previousRentalType === undefined) &&
      this.selectedRentalType === 'is_airport_transfer';

    const condition2 =
      this.previousRentalType === 'is_airport_transfer' &&
      (this.selectedRentalType === 'is_with_driver' ||
        this.selectedRentalType === 'is_without_driver');

    return condition1 || condition2;
  }
  setDataSearch() {
    this.dataSearch.rental_type = this.selectedRentalType;
    if (this.comparePreviousAndCurrentRentalType()) {
      this.onResetLocationInput();
    }
    this.searchBarDataService.setSearchData(this.dataSearch);
    this.onSwitchRentalType.emit(this.selectedRentalType);
    this.previousRentalType = this.selectedRentalType;
  }
  updateDirection() {
    this.atDirection = this.atDirection === 0 ? 1 : 0;
    this.dataSearch.at_direction = this.atDirection;
    // const value = this.getValueSearchParams();
    // this.searchResultService.setQueryParamData(value);
    this.searchBarDataService.setSearchData(this.dataSearch);
  }
  formatDateTimeTemplate(value: any, time?: string) {
    if (time) {
      return this.customDateTimeService.formatDate(value, DateFormat.DATE_SHORT) + ` ${time}`;
    }
    return this.customDateTimeService.formatDate(value, DateFormat.DATE_SHORT);
  }

  @ViewChild('timePicker') timePicker: Calendar;
  pickupTime: Date = new Date();
  selectedSeconds: number;

  selectPickupTime(): void {
    this.selectedSeconds =
      this.pickupTime?.getHours()! * 3600 + this.pickupTime?.getMinutes()! * 60;
    this.dataSearch.at_pickup_time = this.selectedSeconds;
    // const value = this.getValueSearchParams();
    // this.searchResultService.setQueryParamData(value);
    this.searchBarDataService.setSearchData(this.dataSearch);
  }
  onBlurAirPortTime() {
    if (this.pickupTime instanceof Date) {
    } else {
      this.pickupTime = new Date();
    }
    this.selectedSeconds = this.pickupTime?.getHours() * 3600 + this.pickupTime?.getMinutes() * 60;
    this.dataSearch.at_pickup_time = this.selectedSeconds;
    this.searchBarDataService.setSearchData(this.dataSearch);
  }
  // pickedTime: { hour: number; minute: number };
  // @Input() initTime: { hour: number; minute: number } | null;
  // openTimePicker() {
  //   if (!this.pickupTime) {
  //     this.pickedTime = {
  //       hour: new Date().getHours(),
  //       minute: new Date().getMinutes()
  //     };
  //   } else {
  //     this.pickedTime = {
  //       hour: this.pickupTime.getHours(),
  //       minute: this.pickupTime.getMinutes()
  //     };
  //   }
  // }

  // clear(timeInput?: HTMLInputElement) {
  //   this.pickupTime = new Date();
  //   timeInput?.focus();
  // }

  // apply(event: any, op: any) {
  //   this.handleSelectTimePicker(this.pickupTime);
  //   if (!this.pickupTime) {
  //     this.pickupTime = new Date();
  //   }
  //   this.selectedSeconds = this.pickupTime.getHours() * 3600 + this.pickupTime.getMinutes() * 60;
  //   this.dataSearch.at_pickup_time = this.selectedSeconds;
  //   // const value = this.getValueSearchParams();
  //   // this.searchResultService.setQueryParamData(value);
  //   this.searchBarDataService.setSearchData(this.dataSearch);
  //   op.hide(event);
  // }

  // handleSelectTimePicker(event: Date) {
  //   const hour = DateTime.fromJSDate(event).get('hour') || 0;
  //   const minute = DateTime.fromJSDate(event).get('minute') || 0;
  //   // this.hour = hour >= 10 ? `${hour}` : `0${hour}`;
  //   // this.minute = minute >= 10 ? `${minute}` : `0${minute}`;
  // }
}

const FAMOUS_PLACE_VN = [
  {
    city_name: 'TP. Hồ Chí Minh',
    airport_name: 'Sân bay Quốc tế Tân Sơn Nhất',
    iata_code: 'SGN',
  },
  {
    city_name: 'Hà Nội',
    airport_name: 'Sân bay Quốc tế Nội Bài',
    iata_code: 'HAN',
  },
  {
    city_name: 'Đà Nẵng',
    airport_name: 'Sân bay Quốc tế Đà Nẵng',
    iata_code: 'DAD',
  },
  {
    city_name: 'Nha Trang',
    airport_name: 'Sân bay Cam Ranh',
    iata_code: 'CXR',
  },
  {
    city_name: 'Phú Quốc',
    airport_name: 'Sân bay Phú Quốc',
    iata_code: 'PQC',
  },
  {
    city_name: 'Hải Phòng',
    airport_name: 'Sân bay Quốc tế Cát Bi',
    iata_code: 'HPH',
  },
  {
    city_name: 'Vinh',
    airport_name: 'Sân bay Vinh',
    iata_code: 'VII',
  },
  {
    city_name: 'Huế',
    airport_name: 'Sân bay Quốc tế Phú Bài',
    iata_code: 'VII',
  },
  {
    city_name: 'Đà Lạt',
    airport_name: 'Sân bay Liên Khương',
    iata_code: 'DLI',
  },
];
const RECOMMEND_AIRPORT_VN = [
  {
    city_name: 'Chu Lai',
    country: 'Vietnam',
    airport_name: 'Sân bay Chu Lai',
    iata_code: 'VCL',
    object_type: 'Airport',
  },
  {
    city_name: 'Thanh Hóa',
    country: 'Vietnam',
    airport_name: 'Sân bay Thọ Xuân',
    iata_code: 'THD',
    object_type: 'Airport',
  },
  {
    city_name: 'Tuy Hòa',
    country: 'Vietnam',
    airport_name: 'Sân bay Tuy Hòa',
    iata_code: 'TBB',
    object_type: 'Airport',
  },
  {
    city_name: 'Pleiku',
    country: 'Vietnam',
    airport_name: 'Sân bay Pleiku',
    iata_code: 'PXU',
    object_type: 'Airport',
  },
  {
    city_name: 'Buôn Ma Thuột',
    country: 'Vietnam',
    airport_name: 'Sân bay Buôn Ma Thuột',
    iata_code: 'BMV',
    object_type: 'Airport',
  },
  {
    city_name: 'Đồng Hới',
    country: 'Vietnam',
    airport_name: 'Sân bay Đồng Hới',
    iata_code: 'VDH',
    object_type: 'Airport',
  },
  {
    city_name: 'Rạch Giá',
    country: 'Vietnam',
    airport_name: 'Sân bay Rạch Giá',
    iata_code: 'VKQ',
    object_type: 'Airport',
  },
  {
    city_name: 'Cà Mau',
    country: 'Vietnam',
    airport_name: 'Sân bay Cà Mau',
    iata_code: 'CAH',
    object_type: 'Airport',
  },
  {
    city_name: 'Điện Biên Phủ',
    country: 'Vietnam',
    airport_name: 'Sân bay Điện Biên',
    iata_code: 'DIN',
    object_type: 'Airport',
  },
  {
    city_name: 'Côn Đảo',
    country: 'Vietnam',
    airport_name: 'Sân bay Côn Đảo',
    iata_code: 'VCS',
    object_type: 'Airport',
  },
  {
    city_name: 'Quảng Ninh',
    country: 'Vietnam',
    airport_name: 'Sân bay Vân Đồn',
    iata_code: 'VDO',
    object_type: 'Airport',
  },
  {
    city_name: 'Quy Nhơn',
    country: 'Vietnam',
    airport_name: 'Sân bay Quy Nhơn',
    iata_code: 'UIH',
    object_type: 'Airport',
  },
];

const DEFAULT_AIRPORT_VN = [
  {
    city_name: 'Hà Nội',
    country: 'Vietnam',
    airport_name: 'Sân bay Quốc tế Nội Bài',
    iata_code: 'HAN',
    object_type: 'Airport',
  },
  {
    city_name: 'TP. Hồ Chí Minh',
    country: 'Vietnam',
    airport_name: 'Sân bay Quốc tế Tân Sơn Nhất',
    iata_code: 'SGN',
    object_type: 'Airport',
  },
  {
    city_name: 'Nha Trang',
    country: 'Vietnam',
    airport_name: 'Sân bay Cam Ranh',
    iata_code: 'CXR',
    object_type: 'Airport',
  },
  {
    city_name: 'Cần Thơ',
    country: 'Vietnam',
    airport_name: 'Sân bay Cần Thơ',
    iata_code: 'VCA',
    object_type: 'Airport',
  },
  {
    city_name: 'Đà Nẵng',
    country: 'Vietnam',
    airport_name: 'Sân bay Quốc tế Đà Nẵng',
    iata_code: 'DAD',
    object_type: 'Airport',
  },
];

const DEFAULT_AIRPORT_US = [
  {
    city_name: 'Los Angeles Metropolitan Area',
    country: 'United States of America',
    airport_name: 'Los Angeles International Airport',
    iata_code: 'LAX',
    object_type: 'Airport',
  },
  {
    city_name: 'Miami',
    country: 'United States of America',
    airport_name: 'Miami International Airport',
    iata_code: 'MIA',
    object_type: 'Airport',
  },
  {
    city_name: 'New York',
    country: 'United States of America',
    airport_name: 'John F. Kennedy International Airport',
    iata_code: 'JFK',
    object_type: 'Airport',
  },
  {
    city_name: 'Chicago',
    country: 'United States of America',
    airport_name: "O'Hare International Airport",
    iata_code: 'ORD',
    object_type: 'Airport',
  },
  {
    city_name: 'San Francisco',
    country: 'United States of America',
    airport_name: 'SFO International Airport',
    iata_code: 'SFO',
    object_type: 'Airport',
  },
];
